/** @jsxImportSource @emotion/react */
import React, { useCallback, useMemo } from 'react';
import { jsx, css } from '@emotion/react';
import Select from 'components/select';
import { defineMessages } from 'components/i18n';
import { useIntl } from 'react-intl-next';

type Props = {
  value: string;
  onChange: (value: any) => void;
}

const IntervalUnitInput: React.FC<Props> = (props) => {
  const {value} = props;
  const intl = useIntl();

  const intervalUnitLabels: {[key: string]: any} = defineMessages({
    day: {
      id: 'sale.IntervalUnitInput.day',
      defaultMessage: 'Day(s)',
    },
    week: {
      id: 'sale.IntervalUnitInput.week',
      defaultMessage: 'Week(s)',
    },
    month: {
      id: 'sale.IntervalUnitInput.month',
      defaultMessage: 'Month(s)',
    },
    year: {
      id: 'sale.IntervalUnitInput.year',
      defaultMessage: 'Year(s)',
    },
  });
  const intervalUnits = [
    {value: 'day', label: intl.formatMessage(intervalUnitLabels.day)},
    {value: 'week', label: intl.formatMessage(intervalUnitLabels.week)},
    {value: 'month', label: intl.formatMessage(intervalUnitLabels.month)},
    {value: 'year', label: intl.formatMessage(intervalUnitLabels.year)},
    // {value: 'quarter', label: 'Quarter(s)'}, // maybe not
    // {value: 'years', label: 'Years(s)'}
  ];

  const handleChange = useCallback(option => {
    props.onChange(option.value)
  },[]);

  const currentOption = useMemo(() => (
    intervalUnits.find((option) => option.value === value))
  ,[value]);

  return (<Select
    options={intervalUnits}
    {...props}
    onChange={handleChange}
    value={currentOption}
  />);
};

export default IntervalUnitInput;
